import client from '../httpClient';

const customerKeymalisContractsApi = (customerId) => {
  const params = { customerId };
  return client.get('/customers/keymalis-contracts', { params });
};

export default customerKeymalisContractsApi;
